import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

const modalRoot = document.getElementById("modal");

function ShowPortal({ children }) {
	const elRef = useRef(null);

	if (!elRef.current) {
		elRef.current = document.createElement("div");
	}

	useEffect(() => {
		modalRoot.appendChild(elRef.current);

		return () => modalRoot.removeChild(elRef.current);
	});

	return createPortal(children, elRef.current);
}

export { ShowPortal };
